import type { AxiosPromise } from 'axios';
import { type ClientContext, ContextClient } from '~/services/contextClient';
import type { ExtendedAxiosRequestConfig } from '~/services/BaseClient';
import FranchiseHubClientFactory from './franchiseHubClient.factory';
import type {
    FranchiseHubClientInterface,
    FranchiseHubDashboardResponse,
    FranchiseHubLayoutDocument,
    FranchiseHubLayoutResponse,
} from './franchiseHubClient.types';

class FranchiseHubClient extends ContextClient<FranchiseHubClientInterface> {
    constructor() {
        super(FranchiseHubClientFactory);
    }

    getDashboard(
        context: ClientContext,
        extraConfig?: ExtendedAxiosRequestConfig
    ): AxiosPromise<FranchiseHubDashboardResponse> {
        const client = this.getClient(context);
        return client.getDashboard(extraConfig);
    }

    updateLayout(context: ClientContext, layout: FranchiseHubLayoutDocument): AxiosPromise<FranchiseHubLayoutResponse> {
        const client = this.getClient(context);
        return client.updateLayout(layout);
    }

    deleteLayout(context: ClientContext): AxiosPromise<void> {
        const client = this.getClient(context);
        return client.deleteLayout();
    }
}

export default new FranchiseHubClient();
